export const sharedMobile = {
    apartment: {
        total: {
            paid: 'שולם עד היום לשנת {{year}} ',
            special: 'חובות מיוחדים',
            ongoing: 'חובות שוטפים',
            up_to_date: 'עדכני לתאריך',
        },
        paid_payments: {
            title: 'תשלומים אחרונים',
            receipt: 'קבלה',
            unable_download_invoice: 'לא ניתן להוריד את הקובץ, נסה שוב מאוחר יותר',
        },
        future_payments: {
            title: 'תשלומים עתידיים',
            for: 'ל:',
            ongoing_total: 'סך הכל תשלומים עתידיים:',
            number_of_payments: 'מספר תשלומים:',
            cancel_dialog: {
                title: "ביטול תשלומים",
                description: "בחר את התשלומים העתידיים שברצונך לבטל",
                date: "תאריך תשלום",
                amount: "סכום",
                cancel_all: "ביטול כל התשלומים העתידיים",
                cancel_selected: "ביטול תשלומים נבחרים"
            },
            "cancel_button": "ביטול תוכנית",
            cant_cancel_direct_payment: "לא ניתן לבטל תשלומים שבוצעו ישירות לבניין"
        },
        delete_details_button: {
            main_button_title: 'הסר פרטי אשראי',
            dialog_title: 'הסר פרטים',
            dialog_subtitle: 'האם אתה בטוח שברצונך להסיר את פרטיך מהמערכת? זו פעולה אשר לא ניתן לבטל.',
            dialog_button: 'הסר פרטים',
            delete_done: 'פרטים נמחקו',
            delete_failed: 'לא ניתן למחוק את הפרטים, נסה שוב מאוחר יותר'
        },
        show_more: 'הצג עוד',
        paid_for: 'תשלום עבור',
        comment: 'הערת תשלום:',
    }
}
